import { inject, Injectable } from '@angular/core';
import { APP_TOKEN, AppsEnum } from '@itb-monorepo/enums';

declare global {
  interface Window {
    oaiq?: (
      command: 'measure',
      event: 'registration_completed',
      data: { type: 'customer_action' }
    ) => void;
  }
}

@Injectable({
  providedIn: 'root',
})
export class OpenAiPixelService {
  private app = inject(APP_TOKEN);
  private trackedRegistrations = new Set<string>();

  trackRegistration(userId: string): void {
    if (
      this.app !== AppsEnum.TRADER ||
      typeof window === 'undefined' ||
      typeof window.oaiq !== 'function' ||
      !userId ||
      this.trackedRegistrations.has(userId)
    ) {
      return;
    }

    const key = `openai_pixel_registration_${userId}`;
    try {
      if (window.localStorage.getItem(key)) {
        return;
      }
    } catch {
      // In-memory deduplication still works when browser storage is disabled.
    }

    try {
      window.oaiq('measure', 'registration_completed', {
        type: 'customer_action',
      });
      this.trackedRegistrations.add(userId);
    } catch {
      // Tracking must never interrupt registration or the subsequent sign-in.
      return;
    }

    try {
      window.localStorage.setItem(key, '1');
    } catch {
      // Keep the in-memory marker when persistent storage is unavailable.
    }
  }
}
